import { Line } from "@react-three/drei";
import { AlignmentLineType } from "../../types/floorplannerTypes";
import { observer } from "mobx-react-lite";
import { CANVAS_ACCENT_COLOR } from "../../constants/brandColors";

interface AlignmentLineProps {
    line: AlignmentLineType;
}
const AlignmentLine: React.FC<AlignmentLineProps> = observer(({ line }) => {
    const noopRaycast = () => null;

    return (
        line.axis === "x" ? (
            <Line
                key={`align-x-${line.id}`}
                points={[[line.hit.x, -1000, 0], [line.hit.x, 1000, 0]]}
                color={CANVAS_ACCENT_COLOR}
                lineWidth={0.5}
                raycast={noopRaycast}
            />
        ) : (
            <Line
                key={`align-y-${line.id}`}
                points={[[-1000, line.hit.y, 0], [1000, line.hit.y, 0]]}
                color={CANVAS_ACCENT_COLOR}
                lineWidth={0.5}
                raycast={noopRaycast}
            />
        )
    );
})

export default AlignmentLine;